import axios from 'axios';
import { getVidCloudMgmtUrl, getVidCloudPrivUrl } from './environment/environmentService';
import * as oauthService from './oauth/oauthService';

/**
 * Returns the base URL of the local Express server (port 3001).
 * Mirrors the same logic used in SocketService.js so both REST and WebSocket
 * calls resolve to the correct host in every environment.
 */
const getLocalServerUrl = () => {
    const hostname = window.location.hostname;
    const port = 3001;

    if (hostname.includes("pre")) {
        return "https://pre-centralized.vidsigner.net";
    }

    if (hostname.includes("centralized")) {
        return "https://centralized.vidsigner.net";
    }

    return `http://192.168.1.101:${port}`;
};

const vcService = {
    getCredentialQR: (userGuid, body) => {
        return axios.post(`${getVidCloudMgmtUrl()}/vidmobileuser/${userGuid}/credentials/certificate`, body, oauthService.oauthHeaders());
    },
    getSignatureQR: (userGuid, body) => {
        return axios.post(`${getVidCloudMgmtUrl()}/vidmobileuser/${userGuid}/credentials/presentation`, body, oauthService.oauthHeaders());
    },
    updateCredentialStatus: (userGuid, issuanceId, status) => {
        const body = {
            Status: status
        };
        return axios.put(
            `${getVidCloudMgmtUrl()}/vidmobileuser/${userGuid}/credentials/${issuanceId}/status`,
            body,
            oauthService.oauthHeaders()
        );
    },
    updateCredentialPresentationStatus: (userGuid, requestId, status) => {
        const body = {
            Status: status
        };
        return axios.put(
            `${getVidCloudMgmtUrl()}/vidmobileuser/${userGuid}/credentials/presentation/${requestId}/status`,
            body,
            oauthService.oauthHeaders()
        );
    },
    revokeCertificateCredentials: (userGuid, certificateGuid) => {
        return axios.put(
            `${getVidCloudMgmtUrl()}/vidmobileuser/${userGuid}/credentials/certificate/${certificateGuid}/revoke`,
            {},
            oauthService.oauthHeaders()
        );
    },
    QuesacSignature: (requestId, body) => {
        return axios.post(
            `${getVidCloudPrivUrl()}/vidmobileuser/signature/qesac/${requestId}`,
            body,
            oauthService.oauthHeaders()
        );
    },
    /**
     * Polls the local Express server for a stored credential operation.
     * Returns the full operation payload if found (entry is deleted server-side after this call),
     * or an empty object {} if not found.
     *
     * Used as a fallback when the WebSocket disconnects during a mobile deeplink redirect.
     *
     * @param {string} requestId
     */
    getOperationByRequestId: (requestId) => {
        return axios.get(`${getLocalServerUrl()}/api/credentialrequest/${requestId}/operation`);
    },
}

export default vcService;

